<p-toast key="nurseUpdate"></p-toast>
<!-- Update Nurse Container -->
<div class="update-nurse-container">
  <!-- Header Section -->
  <div class="nurse-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="nurse-title">
          <i class="pi pi-user-edit mr-3"></i>
          Update Nurse
        </h1>
        <p class="nurse-subtitle">
          Update professional nurse information
        </p>
      </div>
      <div class="header-right">
        <div class="nurse-status">
          <i class="pi pi-pencil status-icon"></i>
          Update Profile
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="nurse-content">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="nurse-form">
      <!-- Personal Information Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-user mr-2"></i>
            Personal Information
          </h2>
        </div>
        <div class="form-grid">
          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-user mr-2"></i>
              First Name *
            </label>
            <input
              type="text"
              formControlName="first_name"
              class="modern-input"
              placeholder="Enter first name"
            />
            <div
              *ngIf="submitted && userForm.get('first_name')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['first_name'] &&
                  f['first_name'].errors &&
                  f['first_name'].errors['required']
                "
                severity="error"
                text="Please enter your first name"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-user mr-2"></i>
              Last Name *
            </label>
            <input
              type="text"
              formControlName="last_name"
              class="modern-input"
              placeholder="Enter last name"
            />
            <div
              *ngIf="submitted && userForm.get('last_name')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['last_name'] &&
                  f['last_name'].errors &&
                  f['last_name'].errors['required']
                "
                severity="error"
                text="Please enter your last name"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-hashtag mr-2"></i>
              Username *
            </label>
            <input
              type="text"
              formControlName="username"
              class="modern-input"
              placeholder="Enter username"
            />
            <div
              *ngIf="submitted && userForm.get('username')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['username'] &&
                  f['username'].errors &&
                  f['username'].errors['required']
                "
                severity="error"
                text="Please enter a username"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-envelope mr-2"></i>
              Email Address *
            </label>
            <input
              type="email"
              formControlName="email"
              class="modern-input"
              placeholder="Enter email address"
            />
            <div
              *ngIf="submitted && userForm.get('email')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="
                  f &&
                  f['email'] &&
                  f['email'].errors &&
                  f['email'].errors['required']
                "
                severity="error"
                text="Please enter a valid email"
                styleClass="modern-message"
              ></p-message>
              <p-message
                *ngIf="
                  f &&
                  f['email'] &&
                  f['email'].errors &&
                  f['email'].errors['email']
                "
                severity="error"
                text="Please enter a valid email format"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>
        </div>
      </div>

      <!-- Professional Information Section -->
      <div class="content-section">
        <div class="section-header">
          <h2 class="section-title">
            <i class="pi pi-briefcase mr-2"></i>
            Professional Information
          </h2>
        </div>
        <div class="form-grid" [formGroup]="nurseDetailForm">
          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-certificate mr-2"></i>
              SANC Qualification
            </label>
            <p-multiSelect
              [options]="sancQualifications"
              defaultLabel="Select Qualifications"
              formControlName="sanc_qualification"
              class="modern-multiselect w-full"
              [showToggleAll]="false"
              optionLabel="label"
              optionValue="value"
              display="chip"
              appendTo="body"
            ></p-multiSelect>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-id-card mr-2"></i>
              SANC Number *
            </label>
            <input
              type="text"
              formControlName="sanc_number"
              class="modern-input"
              placeholder="Enter SANC number"
            />
            <div
              *ngIf="submitted && nurseDetailForm.get('sanc_number')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="nurseDetailForm.get('sanc_number')?.errors?.['required']"
                severity="error"
                text="Please enter SANC number"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-building mr-2"></i>
              Practice Number *
            </label>
            <input
              type="text"
              formControlName="practice_number"
              class="modern-input"
              placeholder="Enter practice number"
            />
            <div
              *ngIf="
                submitted && nurseDetailForm.get('practice_number')?.errors
              "
              class="error-message"
            >
              <p-message
                *ngIf="nurseDetailForm.get('practice_number')?.errors?.['required']"
                severity="error"
                text="Please enter practice number"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-phone mr-2"></i>
              Contact Number *
            </label>
            <input
              type="text"
              formControlName="contact_number"
              class="modern-input"
              placeholder="Enter contact number"
            />
            <div
              *ngIf="submitted && nurseDetailForm.get('contact_number')?.errors"
              class="error-message"
            >
              <p-message
                *ngIf="nurseDetailForm.get('contact_number')?.errors?.['required']"
                severity="error"
                text="Please enter contact number"
                styleClass="modern-message"
              ></p-message>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">
              <i class="pi pi-phone mr-2"></i>
              Alternate Contact Number
            </label>
            <input
              type="text" 
              formControlName="alternate_contact_number"
              class="modern-input"
              placeholder="Enter alternate contact number"
            />
          </div>
        </div>
      </div>

      <!-- Action Buttons Section -->
      <div class="content-section action-section">
        <div class="action-buttons">
          <button
            type="button"
            class="action-btn secondary"
            (click)="closeDialog()"
          >
            <i class="pi pi-times mr-2"></i>
            Cancel
          </button>
          <button
            type="submit"
            class="action-btn primary"
            [disabled]="loading || !userForm.valid || !nurseDetailForm.valid"
          >
            <i class="pi pi-check mr-2" *ngIf="!loading"></i>
            <i class="pi pi-spinner pi-spin mr-2" *ngIf="loading"></i>
            {{ loading ? "Updating..." : "Update Nurse" }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
